<template>
  <div _hover="bg-[#3D3D3D]" _w="94px" _pos="relative" @mouseover="buttonVisible = true" @mouseleave="buttonVisible = false">
    <img
      :src="src"
      _cursor="pointer"
      width="94px"
      _hover="opacity-[0.7]"
    />
    <div v-show="buttonVisible" _hover="bg-[#3D3D3D]" _flex="~ justify-center items-center" _pos="absolute" _left="0" _top="0" _w="94px" _h="full" _z="1">
      <i class="el-icon-view" _text="[#9A9A9A] 19px" _cursor="pointer" _m="r-15px" @click="buttonViewEvent"></i>
      <i class="el-icon-download" _text="[#9A9A9A] 19px" _cursor="pointer" @click="buttonDownloadEvent"></i>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    src: String,
    buttonViewEvent: Function,
    buttonDownloadEvent: Function
  },
  data() {
    return {
      buttonVisible: false,
      imgResource: null,
    }
  },
}
</script>
